<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">添加关联账号</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <span slot="action" slot-scope="rowItem">
        <a style="margin-right: 20px;" @click="editEvent(rowItem.record)">编辑</a>
        <a @click="updateProviderStatus(rowItem.record)">{{ rowItem.record.accountStatus == 1 ? '禁用' : '启用' }}</a>
      </span>
    </custom-page-table>
    <a-modal title="添加关联账号" :width="666" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="供应商名称" prop="accountName">
          <a-input
            v-model.trim="ruleForm.accountName"
            style="width: 400px;"
            :maxLength="6"
            placeholder="仅用于区分标识数据来源，6个字内"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="接口域名(url)" prop="accountUrl">
          <a-input v-model.trim="ruleForm.accountUrl" style="width: 400px;"></a-input>
        </a-form-model-item>
        <a-form-model-item label="合作方ID(partnerId)" prop="accountPartnerId">
          <a-input v-model.trim="ruleForm.accountPartnerId" style="width: 400px;"></a-input>
        </a-form-model-item>
        <a-form-model-item label="合作方秘钥(Secret)" prop="accountPartnerSecret">
          <a-input v-model.trim="ruleForm.accountPartnerSecret" style="width: 400px;"></a-input>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="submitForm()" style="width: 180px;">提交</a-button>
        </div>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'AddAccount',
  data() {
    return {
      queryParams: {},
      columns: [
        {
          title: '供应商名称',
          dataIndex: 'accountName'
        },
        {
          title: '接口域名',
          dataIndex: 'accountUrl',
          width: '30%'
        },
        {
          title: '合作方ID(partnerId)',
          dataIndex: 'accountPartnerId'
        },
        {
          title: '合作方秘钥(Secret)',
          dataIndex: 'accountPartnerSecret'
        },
        {
          title: '状态',
          dataIndex: 'statusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 120,
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      labelCol: { span: 7 },
      wrapperCol: { span: 14 },
      visible: false,
      loadPromise: params => this.getDataList(params),
      ruleForm: {
        accountUrl: '',
        accountPartnerId: '',
        accountPartnerSecret: '',
        accountName: ''
      },
      rules: {
        accountName: [{ required: true, message: '请输入供应商名称', trigger: 'change' }],
        accountUrl: [{ required: true, message: '请输入接口域名', trigger: 'change' }],
        accountPartnerId: [{ required: true, message: '请输入合作方ID', trigger: 'change' }],
        accountPartnerSecret: [{ required: true, message: '请输入合作方秘钥(Secret)', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CitGroupConnection', title: '商品绑定' },
      { name: 'CitGroupOrderConnection', title: '订单直连' },
      { name: 'CitGroupAddAccount', title: '关联账号' }
    ])
  },
  methods: {
    getDataList(params) {
      params.merchantId = this.$store.getters.userInfo.merchantId
      params.platformId = this.getPlatformConfig().platformId
      return this.getHttpServices().getServerApiService().post('zzTour/account/list/page', params)
    },
    //编辑事件
    editEvent(item) {
      this.getLogUtils().logWithTag('editEvent== item', item)
      this.ruleForm = {
        accountName: item.accountName,
        accountUrl: item.accountUrl,
        accountPartnerId: item.accountPartnerId,
        accountPartnerSecret: item.accountPartnerSecret,
        accountId: item.accountId
      }
      this.visible = true
    },
    //状态更新
    updateProviderStatus(record) {
      let url = 'zzTour/account/status/update'
      let params = {
        status: record.accountStatus == 1 ? 0 : 1,
        accountId: record.accountId
      }
      this.getHttpServices()
        .getServerApiService()
        .post(url, params)
        .then(res => {
          this.$refs.table.refresh(true)
          this.$message.success('状态更新成功')
        })
        .catch(err => {
          this.getLogUtils().logWithTag('err', err)
        })
    },
    //提交事件
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url = this.ruleForm.accountId ? 'zzTour/account/update' : 'zzTour/account/add'
          let params = {
            accountName: this.ruleForm.accountName,
            accountUrl: this.ruleForm.accountUrl,
            accountPartnerId: this.ruleForm.accountPartnerId,
            accountPartnerSecret: this.ruleForm.accountPartnerSecret
          }
          if (this.ruleForm.accountId) {
            params.accountId = this.ruleForm.accountId
          } else {
            params.merchantId = this.$store.getters.userInfo.merchantId
            params.platformId = this.getPlatformConfig().platformId
          }
          this.getHttpServices()
            .getServerApiService()
            .post(url, params)
            .then(res => {
              this.$message.success('保存成功')
              this.visible = false
              this.$refs.table.refresh(true)
            })
            .catch(err => {
              this.$message.error('保存失败')
            })
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    openModel() {
      this.visible = true
      this.ruleForm = {
        accountUrl: '',
        accountPartnerId: '',
        accountPartnerSecret: '',
        accountName: '',
        accountId: null
      }
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
<style scoped></style>
